<template lang="pug">
    div(
        class="_btna",
        :class="_class",
        :style="{ width, height }")
        slot
</template>

<script>
    /**
     * A container that causes enclosed buttons to appear in a row without a
     * separating margin.
     */
    export default {
        name: 'ib-button-array',

        props: {
            /**
             * If `true`, arrange the buttons from top to bottom rather than start to end.
             */
            vertical: Boolean,
            /**
             * Width in any CSS units.
             */
            width: String,
            /**
             * Height in any CSS units.
             */
            height: String
        },

        computed: {
            _class() {
                return '_btna-' + (this.vertical ? 'v' : this.$rtl ? 'r' : 'l');
            }
        }
    }
</script>

<style lang="less">
    @import "../../less/globals.less";

    ._btna {
        display: inline-flex;
        border-radius: @btn-radius;
        .btna-default();

        ._btn {
            margin: 0;
            max-width: none;
            flex: 1 1 auto;
        }

        &-l,
        &-r {
            flex-direction: row;
        }
        &-l ._btn {
            &:not(:first-child) {
                border-top-left-radius: 0;
                border-bottom-left-radius: 0;
                border-left-style: hidden;
                &::after {
                    left: -1px;
                }
            }
            &:not(:last-child) {
                border-top-right-radius: 0;
                border-bottom-right-radius: 0;
            }
            .btna-l-btn();
        }

        &-r ._btn {
            &:not(:first-child) {
                border-top-right-radius: 0;
                border-bottom-right-radius: 0;
                border-right-style: hidden;
                &::after {
                    right: -1px;
                }
            }
            &:not(:last-child) {
                border-top-left-radius: 0;
                border-bottom-left-radius: 0;
            }
            .btna-r-btn();
        }

        &-v {
            flex-direction: column;
        }
        &-v ._btn {
            &:not(:first-child) {
                border-top-left-radius: 0;
                border-top-right-radius: 0;
                border-top-style: hidden;
                &::after {
                    top: -1px;
                }
            }
            &:not(:last-child) {
                border-bottom-left-radius: 0;
                border-bottom-right-radius: 0;
            }
            .btna-v-btn();
        }
    }
</style>

<ib-example id="basic" name="Basic">
    <template lang="pug">
        ib-button-array
            ib-button(:tone="selected == 1 && 'accent'", @click="selected = 1") State 1
            ib-button(:tone="selected == 2 && 'accent'", @click="selected = 2") State 2
            ib-button(:tone="selected == 3 && 'accent'", @click="selected = 3") State 3
            ib-button(:tone="selected == 4 && 'accent'", @click="selected = 4") State 4
    </template>
    <script>
        {
            data() {
                return {
                    selected: 1
                };
            }
        }
    </script>
</ib-example>

<ib-example id="vertical" name="Vertical">
    <template lang="pug">
        ib-button-array(vertical)
            ib-button(:tone="selected == 1 && 'accent'", @click="selected = 1") State 1
            ib-button(:tone="selected == 2 && 'accent'", @click="selected = 2") State 2
            ib-button(:tone="selected == 3 && 'accent'", @click="selected = 3") State 3
            ib-button(:tone="selected == 4 && 'accent'", @click="selected = 4") State 4
    </template>
    <script>
        {
            data() {
                return {
                    selected: 1
                };
            }
        }
    </script>
</ib-example>
